import Image from 'next/image'

const SKY =
  'linear-gradient(in oklab 180deg, oklab(88.6% -0.012 -0.009) 0%, oklab(92.1% -0.010 -0.002) 38%, oklab(95.2% -0.004 0.007) 72%, oklab(96.2% 0.001 0.011) 100%)'
const GROUND = 'linear-gradient(in oklab 180deg, oklab(96% 0.002 0.010 / 0%) 55%, oklab(96% 0.002 0.010 / 85%) 85%, oklab(96% 0.002 0.010) 100%)'

const SpaceBackdrop = ({ wash }: { wash?: boolean }) => (
  <div aria-hidden className="pointer-events-none absolute inset-0 -z-10 overflow-hidden dark:hidden" style={{ backgroundImage: SKY }}>
    <div className="absolute inset-x-0 -top-20 h-[1340px]">
      <Image src="/space/planet-rise.jpg" alt="" fill priority sizes="100vw" className="object-cover object-top" />
    </div>
    <div className="absolute inset-0" style={{ backgroundImage: GROUND }} />
    {wash && <div className="absolute inset-0 bg-white/55" />}
  </div>
)

export default SpaceBackdrop
